import { toArray, first, get } from 'lodash'
import product from '@/service/product'
import { isProduct, IProduct } from '@/service/types'
import { IProductStateDict, isIProductStateDict } from '../types';

export default {
  async countAll(store: any) {
    const response = await product.getCustom({
      items: 1,
    });
    // return get();
  },
  async fetch(store: any, payload: any) {
    const resp: IProductStateDict|void = await product.getAll();
    let a = isIProductStateDict(resp);
    let c = toArray(resp);
    let d = first(c);
    let b = isProduct(d);
    if (a && b) {
      store.commit('UPDATE_PRODUCTS', resp);
    }
    return resp;
  },
  async fetchSelectedProducts(store: any, payload: any) {
    const resp: IProductStateDict|void = await product.getCustom(payload);
    let a = isIProductStateDict(resp);
    let c = toArray(resp);
    let d = first(c);
    let b = isProduct(d);
    if (a && b) {
      store.commit('UPDATE_PRODUCTS', resp);
    }
    return resp;
  },
  async fetchToOtherByEan(store: any, ean: string): Promise<any> {
    const resp: IProductStateDict|void = await product.getCustom({
      where: {
        ean: [ ean ],
      },
    });
    let a = isIProductStateDict(resp);
    let c = toArray(resp);
    let d = first(c);
    let b = isProduct(d);
    if (a && b) {
      store.commit('UPDATE_OTHER_PRODUCT', d);
    }
    return d;
  },
};
